import * as React from 'react';

export const DeactivatedIcon = () => (
  <svg
    width="84"
    height="84"
    viewBox="0 0 84 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M42 82.5C64.3675 82.5 82.5 64.3675 82.5 42C82.5 19.6325 64.3675 1.5 42 1.5C19.6325 1.5 1.5 19.6325 1.5 42C1.5 64.3675 19.6325 82.5 42 82.5Z"
      stroke="#D43F58"
      strokeWidth="3"
    />
    <path
      d="M57.5 30.125L54.875 27.5L42.5 39.875L30.125 27.5L27.5 30.125L39.875 42.5L27.5 54.875L30.125 57.5L42.5 45.125L54.875 57.5L57.5 54.875L45.125 42.5L57.5 30.125Z"
      fill="#D43F58"
    />
  </svg>
);
